angular.module('impactx.dashboard').controller('DashboardCtrl', [
    '$scope',
    'dataGen',
    'MinWidthService',
    'AppConfiguration',
    'ThemeWorldService',
    'ToastService',
    'searchFilter',
    '$context',
    '$workspaceIdHolder',
    'TranslationService',
    DashboardCtrl]);

function DashboardCtrl($scope, dataGen, MinWidthService, AppConfiguration, ThemeWorldService, ToastService, searchFilter, $context, $workspaceIdHolder, TranslationService) {
    MinWidthService.setSpecialMinWidthForDialog($scope, 1024);
    var self = this;
    $scope.gridList = [];
    var getData = function() {
        dataGen.getData($scope, {}, "/dashboard/view").then(function () {
            var maxNumberOfColumns = 0;
            for (var i = 0; i < $scope.data.gridList.grids.length; i++) {
                var gridFromBackend = $scope.data.gridList.grids[i];
                if (!gridFromBackend.fullWidth) {
                    if (gridFromBackend.numberOfColumns > maxNumberOfColumns) {
                        maxNumberOfColumns = gridFromBackend.numberOfColumns;
                    }
                    var grid = [];
                    for (var k = 0; k < gridFromBackend.numberOfRows; k++) {
                        grid[k] = [];
                        for (var j = 0; j < gridFromBackend.numberOfColumns; j++) {
                            grid[k][j] = {};
                        }
                    }
                    self.convertItemsToGrid(grid, gridFromBackend.gridElements);
                    $scope.gridList.push(grid);
                }
                else {
                    gridFromBackend.hidden = {value: false};
                    $scope.gridList.push(gridFromBackend);
                }
            }
            //check if larger than css class
            var offSetCorrection = 250 + 16;
            if (maxNumberOfColumns * 175 + offSetCorrection > 1024) {
                MinWidthService.setSpecialMinWidthForDialog($scope, maxNumberOfColumns * 175 + offSetCorrection);
            }
        });
    };

    this.refreshSearchInfo = function(themeWorldData) {
        dataGen.getData({}, {}, "/search/info").then(function(data) {
            data = data.data;
            if(data !== null && data !== undefined) {
                $context.hasActiveThemeWorldSearch.theme = data.themeWorldTheme;
                $context.hasActiveThemeWorldSearch.value = data.hasActiveThemeWorldSearch;
                $context.hasActiveThemeWorldSearch.id = data.themeWorldSearchId;
                $workspaceIdHolder.themeWorldTheme.value = data.themeWorldTheme;
                TranslationService.add("searchPlaceHolder", data.searchPlaceHolder);
                searchFilter.resetSearchFilter().then(function() {
                    ToastService.openStandardToast(themeWorldData.trns.themeWorldDeactivated);
                    getData();
                });
            }

        });
    };

    if (AppConfiguration.get('leaveThemeWorldOnStartPage') && $context.hasActiveThemeWorldSearch && $context.hasActiveThemeWorldSearch.value) {
        ThemeWorldService.deactivateActiveThemeWorldSearch(true).then(function (data) {
            self.refreshSearchInfo(data);
        });
    }
    else {
        getData();
    }

    self.convertItemsToGrid = function (grid, elements) {
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            grid[element.rowPosition][element.columnPosition].element = element;
            var hidden = {value: false};
            for (var k = element.rowPosition; k < element.rowPosition + element.height; k++) {
                for (var j = element.columnPosition; j < element.columnPosition + element.width; j++) {
                    grid[k][j].hidden = hidden;
                }
            }
        }
    };

    self.checkIfRowIsHidden = function (row) {
        var isHidden = true;
        for (var i = 0; i < row.length; i++) {
            var rowElement = row[i];
            if (!rowElement.hidden || !rowElement.hidden.value) {
                isHidden = false;
                break;
            }
        }
        return isHidden;
    };
}